module.exports = new __parcel__URL__("extra_air_pollution_burden.eaf31489.png").toString();